import { render } from "./RestorePassword.vue?vue&type=template&id=7fd79b1e&scoped=true"
import script from "./RestorePassword.vue?vue&type=script&lang=js"
export * from "./RestorePassword.vue?vue&type=script&lang=js"

import "./RestorePassword.vue?vue&type=style&index=0&id=7fd79b1e&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd79b1e"]])

export default __exports__